import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';

import usePaymentTerms from '~hooks/usePaymentTerms/usePaymentTerms';

import {
  PAYMENT_TERMS_QUERY_KEY,
  RARELY_CHANGED_DATA_STALE_TIME_IN_MS,
} from './constants';

const NO_PAYMENT_TERMS: Awaited<
  ReturnType<ReturnType<typeof usePaymentTerms>['fetchAll']>
> = [];

interface UsePaymentTermsQueryProps {
  companyId?: string;
}

export default function usePaymentTermsQuery({ companyId }: UsePaymentTermsQueryProps) {
  const { fetchAll } = usePaymentTerms();

  const { data, isFetching } = useQuery({
    queryKey: [PAYMENT_TERMS_QUERY_KEY, companyId],
    queryFn: companyId ? ({ signal }) => fetchAll(companyId, signal) : skipToken,
    // Terms change only through this app, and create/update invalidate the prefix.
    staleTime: RARELY_CHANGED_DATA_STALE_TIME_IN_MS,
    // a company switch keeps the previous terms listed so a picked term never falls out of
    // the options while the next company's terms load
    placeholderData: keepPreviousData,
  });

  return { isFetchingPaymentTerms: isFetching, paymentTerms: data ?? NO_PAYMENT_TERMS };
}
